// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Scrolling preview */
.FF_MetadataForm_root_WNAQ0 {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 64rem;
  margin: 0 auto;
  padding: 2rem;

  /* important for flex scrolling */
  min-height: 0; /* allow shrinking within parent */
  min-width: 0;

  overflow: auto;
}

/* Logo */
.FF_MetadataForm_logoWrapper_2TUsi {
  flex: 0 0 auto;
  padding-bottom: 0.5rem;
  width: 100%;
}

/* Form name */
.FF_MetadataForm_title_Sc3xn {
  flex: 0 0 auto;
}

/* All fields wrapper */
.FF_MetadataForm_section_-ITPk {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0;
  margin: 1rem 0;
  border: 1px solid var(--color-border-neutral-decorative, #ebecf2);
  border-radius: var(--border-radius-xs, 0.25rem);
}

.FF_MetadataForm_sectionHeading_nX3Vn {
  background: var(--color-background-secondary-subtlest, #f7f9fc);
  padding: 0.5rem 1rem;
  border-top-left-radius: var(--border-radius-xs, 0.25rem);
  border-top-right-radius: var(--border-radius-xs, 0.25rem);
}

.FF_MetadataForm_sectionFields_WOjc6 {
  display: flex;
  flex-direction: column;
  padding: 0.625rem 1.5rem 0.75rem 1.5rem;
}

.FF_MetadataForm_fieldsMap_oUUOu {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 0;
}

.FF_MetadataForm_row_Tx2Jq {
  display: grid;
  grid-template-columns: repeat(var(--max-columns, 4), minmax(0px, 1fr));
  align-items: flex-start;
  column-gap: 0.625rem;
  row-gap: 0;
  width: 100%;
}

.FF_MetadataForm_fieldWrapper_JriMx {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.75rem;
}

/* Column Span */
.FF_MetadataForm_fieldWrapperColSpan1_57dAA {
  grid-column-end: span 1;
}

.FF_MetadataForm_fieldWrapperColSpan2_DgaY2 {
  grid-column-end: span 2;
}

.FF_MetadataForm_fieldWrapperColSpan3_FnD43 {
  grid-column-end: span 3;
}

.FF_MetadataForm_fieldWrapperColSpan4_MQqGS {
  grid-column-end: span 4;
}

/* DataTable - global class reference */
/* Note: This global class is used by DataTableField component */

/* TabletXSmall */
@media (max-width: 767px) {
  .FF_MetadataForm_root_WNAQ0 {
    padding: 1.25rem 1rem;
  }
  .FF_MetadataForm_row_Tx2Jq {
    /* Use min of MAX_COLUMNS or 2 for tablet - set via inline style */
    grid-template-columns: repeat(var(--tablet-columns, 2), minmax(0px, 1fr));
  }
  /* Logo */
  .FF_MetadataForm_logoWrapper_2TUsi {
    padding-bottom: 0.25rem;
  }
  /* Global class reference for BrandingLogo */
  .FF_MetadataForm_root_WNAQ0 .FF-BrandingLogo-img {
    height: 3rem;
    width: 3rem;
    max-height: 3rem;
    max-width: 3rem;
  }
  .FF_MetadataForm_sectionFields_WOjc6 {
    padding: 1.25rem;
  }
}

/* MobileXLarge */
@media (max-width: 599px) {
  .FF_MetadataForm_row_Tx2Jq {
    /* Always 1 column on mobile, regardless of MAX_COLUMNS */
    grid-template-columns: repeat(var(--mobile-columns, 1), minmax(0px, 1fr));
  }
  /* Column Span - All fields become full-width on mobile */
  .FF_MetadataForm_fieldWrapperColSpan1_57dAA,
  .FF_MetadataForm_fieldWrapperColSpan2_DgaY2,
  .FF_MetadataForm_fieldWrapperColSpan3_FnD43,
  .FF_MetadataForm_fieldWrapperColSpan4_MQqGS {
    grid-column-end: span 1;
  }
  .FF_MetadataForm_sectionFields_WOjc6 {
    padding: 1rem;
  }
}

.FF_MetadataForm_compositeDuplicateBanner_DfVAT {
  margin: 0 1.5rem 0.5rem;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `FF_MetadataForm_root_WNAQ0`,
	"logoWrapper": `FF_MetadataForm_logoWrapper_2TUsi`,
	"title": `FF_MetadataForm_title_Sc3xn`,
	"section": `FF_MetadataForm_section_-ITPk`,
	"sectionHeading": `FF_MetadataForm_sectionHeading_nX3Vn`,
	"sectionFields": `FF_MetadataForm_sectionFields_WOjc6`,
	"fieldsMap": `FF_MetadataForm_fieldsMap_oUUOu`,
	"row": `FF_MetadataForm_row_Tx2Jq`,
	"fieldWrapper": `FF_MetadataForm_fieldWrapper_JriMx`,
	"fieldWrapperColSpan1": `FF_MetadataForm_fieldWrapperColSpan1_57dAA`,
	"fieldWrapperColSpan2": `FF_MetadataForm_fieldWrapperColSpan2_DgaY2`,
	"fieldWrapperColSpan3": `FF_MetadataForm_fieldWrapperColSpan3_FnD43`,
	"fieldWrapperColSpan4": `FF_MetadataForm_fieldWrapperColSpan4_MQqGS`,
	"compositeDuplicateBanner": `FF_MetadataForm_compositeDuplicateBanner_DfVAT`
};
export default ___CSS_LOADER_EXPORT___;
